import Requester from "../helpers/Requester";
import App from "../layouts/app";
import { router } from "@inertiajs/react";
import ContentWrapper from "../components/ContentWrapper";
import PageTitle from "../components/PageTitle";
import OpponentForm from "../components/OpponentForm";

export default function OpponentAdd() {

    const saveOpponent = (form: any) => {
        const requester = new Requester();

        const data = new FormData();

        Object.keys(form).forEach((key) => {
            data.append(key, form[key]);
        });

        requester.post(requester.getUrl(`api/opponents`), data).then((response) => {
            router.visit(`/admin/opponents`);
        }).catch((error) => {
            alert("Error adding opponent: " + error.message);
        })
    }

    return (
        <App>
            <PageTitle title="Add Opponent" />
            <ContentWrapper>
                <OpponentForm onSubmit={saveOpponent} />
            </ContentWrapper>
        </App >
    )
}